import { render, staticRenderFns } from "./total.vue?vue&type=template&id=becf2726&scoped=true&"
import script from "./total.vue?vue&type=script&lang=js&"
export * from "./total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf2726",
  null
  
)

export default component.exports